import { useTranslation } from "react-i18next";

import { useWorkspaceSettingsStore } from "../../store/useWorkspaceSettingsStore";

import { SettingsCard } from "./SettingsCard";

import { Switch } from "@/components/ui/switch";

export const StudentReservationsStatusCard = () => {
  const { t } = useTranslation(["workspaces"]);
  const { settings } = useWorkspaceSettingsStore();

  if (!settings) return null;

  const { user_status } = settings;
  const isReservationsDisabled = user_status.has_reservations_disabled;

  const getReservationsInfo = () => {
    if (isReservationsDisabled) {
      return {
        icon: "mdi:calendar-remove",
        title: t("workspaces:settings.studentReservations.disabled", {
          defaultValue: "Reservations Disabled",
        }),
        description:
          user_status.reservations_disabled_reason ||
          t("workspaces:settings.studentReservations.disabledReason", {
            defaultValue: "New reservations are currently disabled",
          }),
        status: t("workspaces:settings.studentReservations.disabledStatus", {
          defaultValue: "Disabled",
        }),
        variant: "destructive" as const,
        topCircle: "from-red-600 to-pink-500",
        bottomCircle: "from-red-500 to-orange-500",
      };
    }

    return {
      icon: "mdi:calendar-plus",
      title: t("workspaces:settings.studentReservations.enabled", {
        defaultValue: "Reservations Enabled",
      }),
      description: t("workspaces:settings.studentReservations.enabledDescription", {
        defaultValue: "You can book lessons with your tutor",
      }),
      status: t("workspaces:settings.studentReservations.enabledStatus", {
        defaultValue: "Enabled",
      }),
      variant: "default" as const,
      topCircle: "from-green-600 to-blue-500",
      bottomCircle: "from-green-500 to-teal-500",
    };
  };

  const reservationsInfo = getReservationsInfo();

  const action = (
    <div className="flex items-center space-x-2">
      <Switch
        disabled
        checked={!isReservationsDisabled}
        className="scale-75 data-[disabled]:cursor-default! data-[disabled]:opacity-100!"
      />
    </div>
  );

  return (
    <SettingsCard
      action={action}
      bottomCircle={reservationsInfo.bottomCircle}
      bottomCirclePlacement="bottom-right"
      bottomCircleSize="h-24 w-24"
      description={reservationsInfo.description}
      icon={reservationsInfo.icon}
      title={reservationsInfo.title}
      topCircle={reservationsInfo.topCircle}
      topCirclePlacement="top-left"
      topCircleSize="h-20 w-20"
    />
  );
};
